<template>
  <b-container class="mt-5">
    <b-row class="mb-5">
      <b-col cols="6">
        <a href="https://heedesk.io" target="_blank">
          <img alt="" src="../../../assets/images/logo-dark.svg" width="300" />
        </a>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <h1 class="text-primary">{{ total }}€</h1>
    </b-row>
    <b-row class="mt-1">
      <h2>Envoyé par {{ company.name }}</h2>
    </b-row>
    <b-row class="mt-4">
      <h3>Émis le {{ sendDate | formatDate }}</h3>
    </b-row>
    <b-row class="mt-5 mx-3">
      <b-col cols="6">
        <slot name="status-button"></slot>
      </b-col>
      <b-col class="d-flex justify-content-end" cols="6">
        <h-b-action
          :positive="false"
          class="w-50"
          icon="bx bx-cloud-download"
          text="Télécharger (PDF)"
          @click.native="generatePdf"
        >
        </h-b-action>
      </b-col>
    </b-row>
    <b-card class="mt-4 shadow p-3 mb-5">
      <b-row>
        <b-col cols="12">
          <h4>
            {{ company.name }}
          </h4>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6">
          <h5>
            {{ company.address }}
          </h5>
          <h5>{{ company.postal_code }} {{ company.city }}</h5>
          <h5>
            {{ company.country }}
          </h5>
          <h5 class="mt-5">SIRET : {{ company.siret }}</h5>
        </b-col>
        <b-col cols="6">
          <h4 class="d-flex justify-content-end mb-4">
            {{ client.name }}
          </h4>
          <h5 class="d-flex justify-content-end">
            {{ client.address }}
          </h5>
          <h5 class="d-flex justify-content-end">{{ client.postal_code }} {{ client.city }}</h5>
          <h5 class="d-flex justify-content-end">
            {{ client.country }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <h5>
            {{ documentNumber }}
          </h5>
          <h5 v-if="sendDate">Date de d'émission: {{ sendDate | formatDate }}</h5>
          <h5 v-if="expirationDate">Date limite de payment: {{ expirationDate | formatDate }}</h5>
        </b-col>
      </b-row>
      <b-row class="mt-4 bg-light" style="height: 50px">
        <b-col cols="4">
          <h4 class="m-0 d-flex align-items-center h-100">Détails</h4>
        </b-col>
        <b-col cols="2">
          <h4 class="m-0 d-flex align-items-center justify-content-center h-100">Qté</h4>
        </b-col>
        <b-col cols="2">
          <h4 class="m-0 d-flex align-items-center justify-content-center h-100">Prix unitaire</h4>
        </b-col>
        <b-col cols="2">
          <h4 class="m-0 d-flex align-items-center justify-content-center h-100">TVA %</h4>
        </b-col>
        <b-col cols="2">
          <h4 class="m-0 d-flex align-items-center justify-content-center h-100">Total HT</h4>
        </b-col>
      </b-row>
      <b-row v-for="(line, index) in lines" :key="index" class="mt-2">
        <b-col cols="4">
          <p>
            {{ line.name }}
          </p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ line.quantity }}
          </p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ line.price }}
          </p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ line.taxes }}
          </p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ line.total | formatTotal(line) }}
          </p>
        </b-col>
      </b-row>
      <b-row v-if="deliveryCost !== 0" class="mt-2">
        <b-col cols="4">
          <p>Livraison</p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">1</p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ deliveryCost }}
          </p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ deliveryTaxes }}
          </p>
        </b-col>
        <b-col cols="2">
          <p class="m-0 d-flex align-items-center justify-content-center h-100">
            {{ deliveryCost }}
          </p>
        </b-col>
      </b-row>
      <b-row class="d-flex flex-column align-items-end mt-3">
        <b-col class="border-top pt-3" cols="6">
          <b-row>
            <b-col class="d-flex justify-content-center align-items-center" cols="6">
              <h4>Total HT</h4>
            </b-col>
            <b-col class="d-flex justify-content-center align-items-center" cols="6">
              <h5>
                {{ subTotal }}
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex justify-content-center align-items-center" cols="6">
              <h4>TVA</h4>
            </b-col>
            <b-col class="d-flex justify-content-center align-items-center" cols="6">
              <h5>
                {{ taxes }}
              </h5>
            </b-col>
          </b-row>
          <b-row class="bg-light">
            <b-col class="d-flex justify-content-center align-items-center" cols="6">
              <h4>Total</h4>
            </b-col>
            <b-col class="d-flex justify-content-center align-items-center" cols="6">
              <h5>
                {{ total }}
              </h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="d-flex justify-content-center align-items-center" cols="12">
              <h4 v-if="company.vat_exemption">TVA non applicable, article 293B du CGI</h4>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-3 mt-4">
        <b-col v-if="payments" cols="6">
          <h3>Informations de paiement</h3>
          <b-row v-if="payments" class="mt-3 bg-light align-items-center py-2">
            <b-col cols="4" class="d-flex justify-content-center">
              <h4 class="m-0">Date</h4>
            </b-col>
            <b-col cols="4" class="d-flex justify-content-center">
              <h4 class="m-0">Montant</h4>
            </b-col>
            <b-col cols="4" class="d-flex justify-content-center">
              <h4 class="m-0">Méthode</h4>
            </b-col>
          </b-row>
          <b-row v-for="payment in payments" :key="payment.id" class="mt-1">
            <b-col cols="4" class="h6 d-flex justify-content-center">
              {{ payment.created_at | formatDate }}
            </b-col>
            <b-col cols="4" class="h6 d-flex justify-content-center"> {{ payment.amount }} € </b-col>
            <b-col cols="4" class="h6 d-flex justify-content-center">
              {{ payment.payment_method | formatPaymentMethod }}
            </b-col>
          </b-row>
          <b-row v-if="payments" class="mt-3">
            <b-col cols="12" class="d-flex align-items-center">
              <h4>Restant à payer :</h4>
              <h5 class="ml-2">{{ totalDue }} €</h5>
            </b-col>
          </b-row>
          <h5>BIC : {{ company.bic }}</h5>
          <h5>IBAN : {{ company.iban }}</h5>
        </b-col>
      </b-row>
      <b-row class="border-top">
        <h5 class="mt-3 px-3">
          {{ footer }}
        </h5>
      </b-row>
    </b-card>
    <vue-html2pdf
      ref="html2Pdf"
      :enable-download="true"
      :filename="documentNumber"
      :float-layout="true"
      :manual-pagination="false"
      :paginate-elements-by-height="2480"
      :pdf-quality="2"
      :preview-modal="true"
      :show-layout="false"
      pdf-content-width="800px"
      pdf-format="a4"
    >
      <section slot="pdf-content">
        <b-card class="mt-4 shadow p-3 mb-5">
          <b-row>
            <b-col cols="12">
              <h4>
                {{ company.name }}
              </h4>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="6">
              <h5>
                {{ company.address }}
              </h5>
              <h5>{{ company.postal_code }} {{ company.city }}</h5>
              <h5>
                {{ company.country }}
              </h5>
              <h5 class="mt-5">SIRET : {{ company.siret }}</h5>
            </b-col>
            <b-col cols="6">
              <h4 class="d-flex justify-content-end mb-4">
                {{ client.name }}
              </h4>
              <h5 class="d-flex justify-content-end">
                {{ client.address }}
              </h5>
              <h5 class="d-flex justify-content-end">{{ client.postal_code }} {{ client.city }}</h5>
              <h5 class="d-flex justify-content-end">
                {{ client.country }}
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <h5>
                {{ documentNumber }}
              </h5>
              <h5 v-if="sendDate">Date de d'émission : {{ sendDate | formatDate }}</h5>
              <h5 v-if="expirationDate">Date limite de payment : {{ expirationDate | formatDate }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-4 bg-light" style="height: 50px">
            <b-col cols="4">
              <h4 class="m-0 d-flex align-items-center h-100">Détails</h4>
            </b-col>
            <b-col cols="2">
              <h4 class="m-0 d-flex align-items-center justify-content-center h-100">Qté</h4>
            </b-col>
            <b-col cols="2">
              <h4 class="m-0 d-flex align-items-center justify-content-center h-100">Prix unitaire</h4>
            </b-col>
            <b-col cols="2">
              <h4 class="m-0 d-flex align-items-center justify-content-center h-100">TVA %</h4>
            </b-col>
            <b-col cols="2">
              <h4 class="m-0 d-flex align-items-center justify-content-center h-100">Total HT</h4>
            </b-col>
          </b-row>
          <b-row v-for="(line, index) in lines" :key="index" class="mt-2">
            <b-col cols="4">
              <h5>
                {{ line.name }}
              </h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ line.quantity }}
              </h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ line.price }}
              </h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ line.taxes }}
              </h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ line.total | formatTotal(line) }}
              </h5>
            </b-col>
          </b-row>
          <b-row v-if="deliveryCost !== 0" class="mt-2">
            <b-col cols="4">
              <h5>Livraison</h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">1</h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ deliveryCost }}
              </h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ deliveryTaxes }}
              </h5>
            </b-col>
            <b-col cols="2">
              <h5 class="m-0 d-flex align-items-center justify-content-center h-100">
                {{ deliveryCost }}
              </h5>
            </b-col>
          </b-row>
          <b-row class="d-flex flex-column align-items-end mt-3">
            <b-col class="border-top pt-3" cols="6">
              <b-row>
                <b-col class="d-flex justify-content-center align-items-center" cols="6">
                  <h4>Total HT</h4>
                </b-col>
                <b-col class="d-flex justify-content-center align-items-center" cols="6">
                  <h5>
                    {{ subTotal }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex justify-content-center align-items-center" cols="6">
                  <h4>TVA</h4>
                </b-col>
                <b-col class="d-flex justify-content-center align-items-center" cols="6">
                  <h5>
                    {{ taxes }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="bg-light">
                <b-col class="d-flex justify-content-center align-items-center" cols="6">
                  <h4>Total</h4>
                </b-col>
                <b-col class="d-flex justify-content-center align-items-center" cols="6">
                  <h5>
                    {{ total }}
                  </h5>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col class="d-flex justify-content-center align-items-center" cols="12">
                  <h4 v-if="company.vat_exemption">TVA non applicable, article 293B du CGI</h4>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-4">
            <b-col cols="6">
              <h3>Informations de paiement</h3>
              <b-row class="mt-3 bg-light align-items-center py-2">
                <b-col cols="4" class="d-flex justify-content-center">
                  <h4 class="m-0">Date</h4>
                </b-col>
                <b-col cols="4" class="d-flex justify-content-center">
                  <h4 class="m-0">Montant</h4>
                </b-col>
                <b-col cols="4" class="d-flex justify-content-center">
                  <h4 class="m-0">Méthode</h4>
                </b-col>
              </b-row>
              <b-row v-for="payment in payments" :key="payment.id" class="mt-1">
                <b-col cols="4" class="h6 d-flex justify-content-center">
                  {{ payment.created_at | formatDate }}
                </b-col>
                <b-col cols="4" class="h6 d-flex justify-content-center"> {{ payment.amount }} € </b-col>
                <b-col cols="4" class="h6 d-flex justify-content-center">
                  {{ payment.payment_method | formatPaymentMethod }}
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="12" class="d-flex align-items-center">
                  <h4>Restant à payer :</h4>
                  <h5 class="ml-2">{{ totalDue }} €</h5>
                </b-col>
              </b-row>
              <h5>BIC : {{ company.bic }}</h5>
              <h5>IBAN : {{ company.iban }}</h5>
            </b-col>
          </b-row>
          <b-row class="border-top">
            <h5 class="mt-3 px-3">
              {{ footer }}
            </h5>
          </b-row>
        </b-card>
      </section>
    </vue-html2pdf>
  </b-container>
</template>

<script>
import moment from 'moment'
import { Invoice } from '@/node-sdk'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'public-document',

  components: {
    VueHtml2pdf,
  },

  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },

    formatTotal(total, invoiceLine) {
      return invoiceLine.price * invoiceLine.quantity
    },

    formatPaymentMethod(paymentMethod) {
      const paymentMethodChoices = Invoice.get_payment_method_choices()
      return paymentMethodChoices.find((paymentMethodChoice) => paymentMethodChoice.value === paymentMethod).text
    },
  },

  props: {
    company: Object,
    client: Object,
    lines: Array,
    subTotal: Number,
    taxes: Number,
    total: Number,
    payments: Array,
    totalDue: Number,
    footer: String,
    sendDate: String,
    documentNumber: String,
    expirationDate: String,
    deliveryCost: {
      type: Number,
      default: 0,
    },
    deliveryTaxes: Number,
  },

  methods: {
    generatePdf() {
      this.$refs.html2Pdf.generatePdf()
    },
  },
}
</script>

<style scoped></style>
